/*global jQuery */
/*!
* FitText.js 1.2
*
* Copyright 2011, Dave Rupert http://daverupert.com
* Released under the WTFPL license
* http://sam.zoy.org/wtfpl/
*
* Date: Thu May 05 14:23:00 2011 -0600
*/

(function( $ ){

  $.fn.fitText = function( kompressor, options ) {

    // Setup options
    var compressor = kompressor || 1,
        settings = $.extend({
          'minFontSize' : Number.NEGATIVE_INFINITY,
          'maxFontSize' : Number.POSITIVE_INFINITY
        }, options);

    return this.each(function(){

      // Store the object
      var $this = $(this);

      // Resizer() resizes items based on the object width divided by the compressor * 10
      var resizer = function () {
        $this.css('font-size', Math.max(Math.min($this.width() / (compressor*10), parseFloat(settings.maxFontSize)), parseFloat(settings.minFontSize)));
      };

      // Call once to set.
      resizer();

      // Call on resize. Opera debounces their resize by default.
      $(window).on('resize.fittext orientationchange.fittext', resizer);

    });

  };

})( jQuery );

/// website

jQuery(document).ready(function($) {

  // Global variables

  var $window = $(window);
  var $body = $('body');
  var $anchors = $('a');
  var screenSm = 768;
  // var debounceDelay = 250;
  // var throttleDelay = 250;
  

  // ===========================================================================
  //
  // Smooth scroll-to links
  // Originally from http://stackoverflow.com/a/7717572/764886
  //
  // Example markup:
  //
  // <a href="#anchor" class="scroll-to">I will scroll</a>

  var $htmlAndBody = $('html, body');
  var $smoothScrollLinks = $('[data-scroll="smooth"]');
  var scrollDuration = 500;

  $smoothScrollLinks.on('click', function (e) {
    e.preventDefault();

    $htmlAndBody.animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, scrollDuration);
  });

  // ===========================================================================
  //
  // Open external links in new window
  // Originally from https://css-tricks.com/snippets/jquery/open-external-links-in-new-window/

  // $anchors.not('a[href*="mailto"]').each(function() {
  //    var a = new RegExp('/' + window.location.host + '/');

  //    if (!a.test(this.href)) {
  //      $(this).on('click', function(e) {
  //         e.preventDefault();
  //         e.stopPropagation();

  //         window.open(this.href, '_blank');
  //      });
  //    }
  // });

  

  // ===========================================================================
  // Equalizers

  // Equalize widths
  // Usage:
  // $('.equal-height').equalHeight();
  // $(window).resize(function() {
  //   $('.equal-height').css('height','auto');
  //   $('.equal-height').equalHeight();
  // });

  $.fn.equalWidth = function() {
      var maxWidth = 0;
      return this.each(function(index, box) {
          var boxWidth = $(box).width();
          maxWidth = Math.max(maxWidth, boxWidth);
      }).width(maxWidth);
  };

  // Equalize heights
  // Usage:
  // $('.equal-height').equalHeight();
  // $(window).resize(function() {
  //   $('.equal-height').css('height','auto');
  //   $('.equal-height').equalHeight();
  // });

  $.fn.equalHeight = function() {
      var maxHeight = 0;
      return this.each(function(index, box) {
          var boxHeight = $(box).height();
          maxHeight = Math.max(maxHeight, boxHeight);
      }).height(maxHeight);
  };

  // ===========================================================================
  // Navigation
  // var navTrigger = $('.js-nav-trigger');
  // var navWrapper = $('.js-nav-wrapper');
  // navWrapper.on('click touch', function(){
  //   navWrapper.toggleClass('menu-open');
  //   $('body').toggleClass('menu-open');
  // });

  // ===========================================================================
  // Messages

  var $messages = $('.message.animated');

  $messages.each(function () {
    var messageDismissStyle = $(this).attr('data-dismissable');

    $(this).on('click', function (e) {
      e.preventDefault();

      $(this)
        .addClass(messageDismissStyle)
        .delay(1000)
        .queue(function(next) {
          $(this).hide();
          next();
        });
    });
  });
  
  // ===========================================================================
  // Carousels

  // hero carousel
  var $carouselHeader = $('.js-header-carousel');
  var carouselHeaderOptions = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true
  };

   // logos carousel
   var $carouselLogos = $('.js-carousel-logos');
   var carouselLogosOptions = {
     dots: false,
     infinite: false,
     speed: 400,
     slidesToShow: 3,
     slidesToScroll: 3,
     rows:2,
     responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
    ]
   };
   var $logosWrapper = $('.logos-slider-wrapper');
   var $currentLogosSlide = $logosWrapper.find('.currentSlide');
   var $totalLogosSlides = $logosWrapper.find('.totalSlides');
   var $logosCounter = $logosWrapper.find('.logos-counter');
  
    function updateLogosCounter(slick, currentSlideIndex) {
      var slidesToShow = slick.options.slidesToShow;
      var slidesToScroll = slick.options.slidesToScroll;
      var totalSets = Math.ceil(slick.slideCount / slidesToShow);
      if (slick.slideCount <= slidesToShow) {
        $logosCounter.hide();
      } else {
        $logosCounter.show();
        $totalLogosSlides.text(totalSets);
        var currentSlide = currentSlideIndex !== undefined ? currentSlideIndex / slidesToScroll : slick.currentSlide;
        $currentLogosSlide.text((currentSlide + 1));
      }
    }
  
    $carouselLogos.on('init', function(event, slick){
      updateLogosCounter(slick);
    });
  
    $carouselLogos.on('afterChange', function(event, slick, currentSlide){
      updateLogosCounter(slick, currentSlide);
    });

  // ===========================================================================
  // Make scrolling comfortable
  //
  // http://stackoverflow.com/a/15821417

  $.fn.scrollfix = function() {
      this.bind('mousewheel DOMMouseScroll', function (e) {
          var delta = e.wheelDelta || (e.originalEvent && e.originalEvent.wheelDelta) || -e.detail,
              bottomOverflow = this.scrollTop + $(this).outerHeight() - this.scrollHeight >= 0,
              topOverflow = this.scrollTop <= 0;

          if ((delta < 0 && bottomOverflow) || (delta > 0 && topOverflow)) {
              e.preventDefault();
          }
      });
      return this;
  };

  $('.scrollfix').scrollfix();

  // ===========================================================================
  // Drawers

  var drawerToggle = $('[data-toggle="drawer"]');
  var drawer = $('.drawer');

  drawerToggle.click(function(e) {
    drawer.filter(this.hash).toggleClass('in');
    e.preventDefault();
  });


  // ===========================================================================

  // ===========================================================================
// tabs navigation
$('.js-tab-nav').on('click', function(event) {
  event.preventDefault(); 
  var index = $(this).index('.js-tab-nav');
  $('.js-tab-nav').removeClass('active');
  $(this).addClass('active');
  $('.js-tabs-carousel').slick('slickGoTo', index);
});

var defaultSlidesToShow = 3;  // Default number of slides to show
var carouselProductsOptions = {
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: defaultSlidesToShow,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1.2,
        // centerMode: true,
        // centerPadding: '30px',
      }
    },
  ]
};

$('.js-carousel-products').each(function() {
  var $carousel = $(this);
  var $currentSlide = $carousel.closest('.tab-pane').find('.currentSlide');
  var $totalSlides = $carousel.closest('.tab-pane').find('.totalSlides');
  var $counter = $carousel.closest('.tab-pane').find('.product-counter');

  function updateSlideCounter(slick, currentSlideIndex) {
    var slidesToShow = slick.options.slidesToShow;
    var totalSets = Math.ceil(slick.slideCount / slidesToShow);
    if (slick.slideCount <= slidesToShow) {
      $counter.hide();
    } else {
      $counter.show();
      $totalSlides.text(totalSets);
      var currentSlide = currentSlideIndex !== undefined ? currentSlideIndex : slick.currentSlide;
      $currentSlide.text((currentSlide + 1));
    }
  }

  $carousel.on('init', function(event, slick){
    updateSlideCounter(slick);
  });

  $carousel.on('afterChange', function(event, slick, currentSlide){
    updateSlideCounter(slick, currentSlide);
  });

  $carousel.on('setPosition breakpoint', function(event, slick){
    updateSlideCounter(slick, slick.currentSlide);
  });

  $carousel.slick(carouselProductsOptions);
});

$('.product-tabs a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
  var target = $(e.target).attr('href');
  $(target).find('.js-carousel-products').slick('setPosition');
});


  function initCarousel () {
    $carouselHeader.slick(carouselHeaderOptions); 
    $carouselLogos.slick(carouselLogosOptions); 
  }

  // ==========================================================================
  // global search

  // function globalSearch() {
  //   var search_trigger = $('.js-global-search-trigger'),
  //   search_form = $('.js-global-search-form');
  //   search_trigger.on('click', function(e){
  //     e.preventDefault();
  //     $('.algolia-autocomplete').after('<div class="js-search-backdrop global-search-form__backdrop"></div>');
  //     search_form.toggleClass('is-visible');
  //   });
  // }

  $(document).ready(function() {
    function toggleSearchForm() {
        var searchForm = $('.js-global-search-form');
        var searchBackdrop = $('.js-search-backdrop');

        // Toggle search form visibility
        searchForm.toggleClass('is-visible');

        // Check if search form is visible and toggle backdrop accordingly
        if (searchForm.hasClass('is-visible')) {
            // If search form is visible and backdrop does not exist, create it
            if (searchBackdrop.length === 0) {
                $('.js-result-search-field').addClass('hide-search-field');
                $('<div class="js-search-backdrop global-search-form__backdrop js-global-search-trigger"></div>').appendTo('body');
            }
        } else {
            // If search form is not visible, remove the backdrop
            $('.js-result-search-field').removeClass('hide-search-field');
            searchBackdrop.remove();
        }
    }

    // Example event to trigger the function
    $('.js-global-search-trigger').on('click', function(e) {
        e.preventDefault();
        toggleSearchForm();
    });
    $(document).on('click', '.js-search-backdrop', function() { 
      toggleSearchForm();
    });
});

// service line search
if ($('.service-line').length > 0) {
  $('#ajaxsearchliteres2').addClass('service-line-search');
} else {
  $('#ajaxsearchliteres2').removeClass('service-line-search');
}

// var input = $('.service-line .proinput input.orig');
// input.placeholder = 'First line\nSecond line';


// =============================================================================
// map

function mapContacts() {
  var mapRegion = $('.js-map-region');
  var mapDropdown = $('.js-map-dropdown');
  var locationBox = $('.js-location-box');
  var dropdownValue = $('.js-map-dropdown-value');

  // color map
  // mapDropdown.each(function(){
  //   var isRegion = $(this).data('map-dropdown');

  // });

  $('.js-map-dropdown').each(function() {
    var dropdownValue = $(this).data('map-dropdown');
    console.log(dropdownValue);
    $('.js-map-region').each(function() {
        if ($(this).data('map-region') === dropdownValue) {
            $(this).addClass('has-info');
        }
    });
  });

  // map click
  mapRegion.on('click touch', function(){
    var selectedRegion = $(this).data('map-region');
    var selectedRegionLabel = $(this).data('map-label');
    dropdownValue.text(selectedRegionLabel);
    console.log(selectedRegion);
    mapRegion.removeClass('active');
    $(this).addClass('active');
    locationBox.each(function(){
      if ($(this).data('region') === selectedRegion ) {
        $(this).addClass('is-in');
      } else {
        $(this).removeClass('is-in');
      }
    });
  });
  // dropdown click
  mapDropdown.on('click touch', function(e) {
    e.preventDefault();
    var selectedRegion = $(this).data('map-dropdown');
    var selectedRegionLabel = $(this).data('map-dropdown-label');
    dropdownValue.text(selectedRegionLabel);
    console.log(selectedRegion);
    // mapRegion.removeClass('active');
    // mapRegion.addClass('active');
    mapRegion.each(function() {
      if ($(this).data('map-region') === selectedRegion) {
          $(this).addClass('active');
      } else {
        $(this).removeClass('active');
      }
    });
    locationBox.each(function(){
      if ($(this).data('region') === selectedRegion ) {
        $(this).addClass('is-in');
      } else {
        $(this).removeClass('is-in');
      }
    });
  });
}

  
  // ===========================================================================
  // post filters
  
    function fetchPosts(page = 1) {
        var selectedCategories = [];
        $('.filter-buttons .active').each(function() {
            selectedCategories.push($(this).data('category'));
        });

        $.ajax({
            url: ajax_vars.ajax_url,
            type: 'POST',
            data: {
                action: 'load_filtered_posts',
                paged: page,
                categories: selectedCategories
            },
            success: function(response) {
                $('.js-posts-container').html(response);
                updatePagination(page);
            },
            error: function(xhr, status, error) {
                console.log('AJAX error:', status, error);
            }
        });
    }

    function updatePagination(currentPage) {
        var totalPages = $('.pagination').data('total-pages');
        $('.pagination-counter').text(currentPage + '/' + totalPages);

        if (currentPage > 1) {
            // $('.pagination-arrow-prev').show();
            // $('.pagination-arrow-prev').show();
            $('.pagination-arrow-prev').css('visibility', 'visible');
        } else {
            // $('.pagination-arrow-prev').hide();
            $('.pagination-arrow-prev').css('visibility', 'hidden');
        }

        if (currentPage < totalPages) {
            // $('.pagination-arrow-next').show();
            $('.pagination-arrow-next').css('visibility', 'visible');
        } else {
            // $('.pagination-arrow-next').hide();
            $('.pagination-arrow-next').css('visibility', 'hidden');

        }
    }

    $('.filter-buttons a').on('click', function(e) {
        e.preventDefault();
        $(this).toggleClass('active');

        // If no filters are active, show all posts
        var activeFilters = $('.filter-buttons .active').length;
        if (activeFilters === 0) {
            fetchPosts();
        } else {
            fetchPosts();
        }
    });

    $(document).on('click', '.pagination-arrow-prev', function(e) {
        e.preventDefault();
        var currentPage = parseInt($('.pagination-counter').text().split('/')[0]);
        fetchPosts(currentPage - 1);
    });

    $(document).on('click', '.pagination-arrow-next', function(e) {
        e.preventDefault();
        var currentPage = parseInt($('.pagination-counter').text().split('/')[0]);
        fetchPosts(currentPage + 1);
    });

    // Initial load with no AJAX to show all posts
    updatePagination(1);




  // ===========================================================================

  // ===========================================================================
  // Bootstrap tabs update

  var tabHashPrefix = 'tab-';

  function afterTabShown(e) {  
    e.preventDefault();

    // Update location hash
    var hash = e.target.hash.substr(1);

    if (hash === '') {
      hash = $(e.target).data('target').substr(1);
    }

    window.location.hash = tabHashPrefix +  hash;
  }

  // Select tabs from on location hash

  function selectTabFromLocationHash() {
    var hash = location.hash;

    if (hash === '') {
      return;
    }

    var $tab = $anchors.filter('[href="' + hash.replace(tabHashPrefix,'') + '"]');

    // If someone uses data-target instead of href for id
    if ($tab.length === 0) {
      $tab = $anchors.filter('[data-target="' + hash.replace('tab-','') + '"]');
    }

    $tab.tab('show');
  }




  $("[data-fancybox]").fancybox({
    backFocus: false,
  }); 


// ===========================================================================
// animations
function animation() {
  $('.animate--base').each(function() {
    var controller = new ScrollMagic.Controller();
    new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: .9,
      offset: 0, // move trigger to center of element
      reverse: false // only do once
    })
    .setClassToggle(this, "visible") // add class toggle
    // .addIndicators() // add indicators (requires plugin)
    .addTo(controller);
  });
}


// ===========================================================================
// Custom nukber input icons
// $('.js-number-up').on('click', function() {
//   var input = $(this).siblings('input[type="number"]');
//   input.val(parseInt(input.val(), 10) + 1);
// });

$('.form-group').on('click', '.js-number-up', function() {
  var input = $(this).siblings('input[type="number"]');
  var currentValue = parseInt(input.val(), 10);
  var maxValue = parseInt(input.attr('max'), 10);
  
  if (isNaN(currentValue)) {
    currentValue = 0; // Default to 0 if the value is NaN
  }
  if (!isNaN(maxValue) && currentValue >= maxValue) {
    input.val(maxValue); // Prevent going above max value
  } else {
    input.val(currentValue + 1);
  }
});

$('.form-group').on('click', '.js-number-down', function() {
  var input = $(this).siblings('input[type="number"]');
  var currentValue = parseInt(input.val(), 10);
  var minValue = parseInt(input.attr('min'), 10);

  if (isNaN(currentValue)) {
    currentValue = 0; // Default to 0 if the value is NaN
  }
  if (!isNaN(minValue) && currentValue <= minValue) {
    input.val(minValue); // Prevent going below min value
  } else {
    input.val(currentValue - 1);
  }
});

// $('.js-number-down').on('click', function() {
//   var input = $(this).siblings('input[type="number"]');
//   input.val(parseInt(input.val(), 10) - 1);
// });

// ===========================================================================
// Navigation (transparent above featured image, white bg below)

// function navBg() {
//   var projectsNav = $('.single-projects_type'),
//   headerHeight = $('.js-hero').height();

//   var controllerNav = new ScrollMagic.Controller({globalSceneOptions: {duration: headerHeight}});
//   // var triggerHook = scene.triggerHook();
//   new ScrollMagic.Scene({triggerElement: ".js-hero", triggerHook: 0})
//       .setClassToggle(".faktotum-auto-hide-header", "no-bg") // add class toggle
//       // .addIndicators() // add indicators (requires plugin)
//       .addTo(controllerNav);
// }

  // replace dropdown blank field
  $('.post-dropdown select option:first-child').text('Appartment');

  // Detect Bootstrap tab shown event
  $('[data-toggle="tab"]').on('shown.bs.tab', afterTabShown);

  /**
   * Initialization
   */
  var init = function () {
    selectTabFromLocationHash();
    // handleBreadcrumbs();
    initCarousel();
    animation();
    mapContacts();
    // globalSearch();
    // navBg();
  };

  var onResize = function () {
    // handleBreadcrumbs();
  };

  var onScroll = function () {
  };

  $window.on('resize', onResize);

  // $window.on('scroll', $.throttle(throttleDelay, onScroll));


  // fittext
  $('.js-home-simple-content').fitText(0.7);
  $('.js-editable-content-element-item').fitText(1);
  $('.js-fluid-bars-text').fitText(2.75);


  // footer menus toggle - mobile
  function bindMenuToggle() {
    $('.footer-menus .menu-item-has-children > a').off('click').on('click', function(event) {
        event.preventDefault();

        $(this).siblings('.sub-menu').slideToggle();
        $('.footer-menus .menu-item-has-children > .sub-menu').not($(this).siblings('.sub-menu')).slideUp();
    });
  }

  function checkWindowSize() {
      if ($(window).outerWidth() < 992) {
          $('.footer-menus .sub-menu').hide();
          bindMenuToggle();
      } else {
          $('.footer-menus .menu-item-has-children > a').off('click');
          $('.footer-menus .sub-menu').show();
      }
  }

 checkWindowSize();
  $(window).resize(function() {
      checkWindowSize();
  });
  // footer menus toggle - mobile - END

  // Map
 setTimeout(() => {
  $('.choices__inner').on('click', () => {
    $('.choices__list--dropdown .choices__list div').each(function() {
      if (!$(this).data('value').startsWith('DE-')) {
          $(this).remove();
      }
  });
  })
 }, 500);
  // Map - END

    // Dropdowns Team
    $('.team-dropdowns .dropdown-menu').on('click', function(e) {
      if ($(e.target).is('label')) {
          e.stopPropagation();
      }
    });

    $('.team-dropdowns input[type="checkbox"]').on('change', function() {
      var checkedRegions = [];
      $('.region-dropdown input[type="checkbox"]:checked').each(function() {
          checkedRegions.push($(this).attr('name'));
      });
      var checkedAreas = [];
      $('.area-dropdown input[type="checkbox"]:checked').each(function() {
          checkedAreas.push($(this).attr('name'));
      });
      var checkedThemes = [];
      $('.thema-dropdown input[type="checkbox"]:checked').each(function() {
          checkedThemes.push($(this).attr('name'));
      });

      $('.team-list').each(function() {
        var region = $(this).data('region');
        var area = $(this).data('area');
        var thema = $(this).data('thema');

        if(
          (!checkedRegions.length || checkedRegions.includes(region)) &&
          (!checkedAreas.length || checkedAreas.includes(area)) &&
          (!checkedThemes.length || checkedThemes.includes(thema))
         ) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
  });
     // Dropdowns Team - END


  // next section scroll
  $('.header__arrow').on('click', function() {
    var $currentSection = $(this).closest('section');
      var scrollToPosition = $currentSection.offset().top + $currentSection.outerHeight() - 50;

      $('html, body').animate({
        scrollTop: scrollToPosition
      }, 600);
  });

  init();

});
